import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';

export type Section = { label: string; total: number };

export async function exportBilanOfficialPDF(options: {
  templateUrl: string; // public URL to the page-7 PDF
  entity: string;
  systemLabel: string; // SN | SMT
  currency: string;
  periodText: string;
  actifs: Section[];
  passifs: Section[];
  filename?: string;
}) {
  const { templateUrl, entity, systemLabel, currency, periodText, actifs, passifs, filename = `bilan_${systemLabel}.pdf` } = options;

  const templateBytes = await fetch(templateUrl).then(r => r.arrayBuffer());
  const pdfDoc = await PDFDocument.load(templateBytes);
  const pages = pdfDoc.getPages();
  const page = pages[0];
  const { width, height } = page.getSize();
  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

  const drawText = (text: string, x: number, y: number, size = 10) => {
    page.drawText(text, { x, y, size, font, color: rgb(0, 0, 0) });
  };

  // Header placements (approx; to be adjusted to template)
  drawText(entity, 60, height - 70, 10);
  drawText(periodText, width / 2 - 120, height - 70, 10);
  drawText(`Système: ${systemLabel}  Devise: ${currency}`, width - 250, height - 70, 10);

  // Table placements (approx): define starting coords and line height
  const startY = height - 160;
  const lineH = 14;
  const colActifX = 60;
  const colActifAmtX = 250;
  const colPassifX = 330;
  const colPassifAmtX = 520;

  const fmt = (n: number) => new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);

  let row = 0;
  const maxRows = Math.max(actifs.length, passifs.length);
  for (row = 0; row < maxRows; row++) {
    const y = startY - row * lineH;
    if (actifs[row]) {
      drawText(actifs[row].label, colActifX, y);
      drawText(fmt(actifs[row].total), colActifAmtX, y);
    }
    if (passifs[row]) {
      drawText(passifs[row].label, colPassifX, y);
      drawText(fmt(passifs[row].total), colPassifAmtX, y);
    }
  }

  // Totals
  const totalActif = actifs.reduce((a, r) => a + (r.total || 0), 0);
  const totalPassif = passifs.reduce((a, r) => a + (r.total || 0), 0);
  const yTot = startY - row * lineH - 6;
  drawText('Total Actif', colActifX, yTot, 11);
  drawText(fmt(totalActif), colActifAmtX, yTot, 11);
  drawText('Total Passif', colPassifX, yTot, 11);
  drawText(fmt(totalPassif), colPassifAmtX, yTot, 11);

  const bytes = await pdfDoc.save();
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}